<div aria-label="error page">
    <header class="b-top border-xl core-water-leaf-border">
        <img width="200px" [src]="logoPath" />
    </header>
    <f-divider color="neutral-mountain-mist"/>
    <div class="main">
        <div class="error-container">
            <p>{{errorMessage}}</p>
        </div>
    </div>
</div>